// API base URL. Override with REACT_APP_API_URL in .env (see .env in this folder).
export const API_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export const TOKEN_KEY = 'aptcrm.token';
